/**
 * Abstrai a navegação de página inteira (full-page redirect) para permitir
 * mock em testes. jsdom (v26+, usado pelo jest-environment-jsdom nesta
 * versão) trata `window.location` como não-configurável: nem `delete`, nem
 * `Object.defineProperty`, nem atribuir `.href` para uma URL cross-origin
 * têm efeito em ambiente de teste (a navegação real é stubada e loga
 * "Not implemented: navigation"). Por isso o redirect passa por aqui em vez
 * de escrever direto em `window.location.href` no componente.
 */
export function redirectTo(url: string): void {
  window.location.href = url;
}
